import { H3 } from '@h3/types';

export default class SchemaMetaData {
    /** 表单结构 */
    schema: H3.Schema.ISchema | null = null;

    /** 视图偏好 */
    preference: Record<string, H3.View.IPreferenceItem[]> = {};

    /** 打印模板 */
    printTemplates: H3.Print.TPrintTemplate[] = [];

    /**
     * 设置表单结构
     * @param schema 表单结构
     */
    setSchema(schema: H3.Schema.ISchema) {
        this.schema = schema;
    }

    /**
     * 设置视图偏好
     * @param viewPageId 标签页Id
     * @param preference 视图偏好
     */
    setPreference(viewPageId: string, preference: H3.View.IPreferenceItem[]) {
        this.preference[viewPageId] = preference;
    }

    /**
     * 设置打印模板
     * @param templates
     */
    setPrintTemplates(templates: H3.Print.TPrintTemplate[]) {
        this.printTemplates = templates;
    }
}
